import { render } from "./ConfigurarReportes.vue?vue&type=template&id=5d28af62"
import script from "./ConfigurarReportes.vue?vue&type=script&lang=js"
export * from "./ConfigurarReportes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__